import type { Page } from '#library/types.ts'

function direct_children(stories: Array<Page>, parent_slug: string): Array<Page> {
	const parent = parent_slug.endsWith('/') ? parent_slug : parent_slug + '/'
	const parent_segments = parent.split('/').filter(Boolean).length

	return stories.filter(story => {
		if (story.full_slug === parent) return false
		if (!story.full_slug.startsWith(parent)) return false

		const segments = story.full_slug.split('/').filter(Boolean).length
		return segments === parent_segments + 1
	})
}

export async function get_sibling_links(api: StoryblokApi, slug: string) {
	const {
		data: { stories }
	} = await api.get('cdn/stories', {
		starts_with: slug,
		content_type: 'page',
		sort_by: 'parent_position:asc',
		per_page: 100,
		version: 'draft',
		resolve_links: 'url'
	})
	const children = direct_children(stories, slug)

	const links = children
		.filter(child => !child?.content?.hide)
		.map(child => ({
			name: child.name,
			link: '/' + child.full_slug,
			children: direct_children(stories, child.full_slug).map(grandchild => ({
				name: grandchild.name,
				link: '/' + grandchild.full_slug
			}))
		}))

	return links
}
